module.exports = __webpack_public_path__ + "img/staging-qr-apk-th-en-page.a3d1a638.png";